
import angular from 'angular'

angular.module('clientDashboardApp').factory('reviewResponseService', function($http) {

  return {
    addNote(review, response, message) {
      return $http.post(`/v5/reviews/${review._id}/responses/${response._id.$oid}/notes`, {"note": message})
        .then(response => response.data)
    },

    updateNote(review, response, note) {
      return $http.put(`/v5/reviews/${review._id}/responses/${response._id.$oid}/notes/${note._id}`, {note})
        .then(response => response.data)
    },

    removeNote(review, response, note) {
      return $http.delete(`/v5/reviews/${review._id}/responses/${response._id.$oid}/notes/${note._id}`)
        .then(response => response.data)
    },

    rejectResponse(review, response, rejectionReason) {
      return $http.post(`/v5/reviews/responses/reject`, { reviewId: review._id, responseId: response._id.$oid, rejectionReason })
    }

  }

})
